/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-access.reducer';

export const DoctorAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorAccessEntity = useAppSelector(state => state.doctorAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorAccess.detail.title">DoctorAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{doctorAccessEntity.comboUser ? doctorAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{doctorAccessEntity.glucoUser ? doctorAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-access/${doctorAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorAccessDetail;
